module.exports = __webpack_public_path__ + "static/media/dashboardActive.7e973906.svg";